import React from "react";
import { Button } from "@mui/material";
import ButtonLoader from "./buttonLoader";
import { cssProperties } from "../utils/commonCssProperties";

export default function SubmitButton({ name, icon, handleSubmit, disabled,onClick }) {
  return (
    <>
      {name === "loader" ? (
        <Button
          size="small"
          varient="contained"
          style={{
            backgroundColor: "#F0F3F7",
            borderRadius: "40px",
            color: "#3F41D1",
            height: "40px",
            padding: '0 24px',
          }}
        >
          <ButtonLoader />
        </Button>
      ) : (
        <Button
          size="small"
          varient="contained"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            backgroundColor: `${disabled ? `rgba(0, 0, 0, 0.12)` : "#0F4F96"}`,
            color: `${disabled ? 'rgba(0, 0, 0, 0.26)' : `${cssProperties?.color?.white}`}`,
            border: "none",
            borderRadius: "40px",
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "bold",
            height: "40px",
            padding: '0 24px',
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
          onClick={handleSubmit}
          disabled={disabled}
        >
          {name}
          {icon}
        </Button>
      )}
    </>
  );
}
